import type { Directive } from "vue";

const findFirstFocusableElement = (el: HTMLElement): HTMLElement | null => {
  const selector = "input, select, textarea, button";

  if (el.matches(selector)) {
    return el;
  }

  return el.querySelector(selector);
};

export const vAutofocus: Directive = {
  mounted(el: HTMLElement) {
    const targetEl = findFirstFocusableElement(el);

    if (!targetEl) {
      return;
    }

    targetEl.focus();
  }
};
